/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_Error_Select_BothInputs */



/**
* | output |
* | --- |
* | "Please select both industry and position" |
*
* @param {Profile_Update_Error_Select_BothInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_update_error_select_both = /** @type {((inputs?: Profile_Update_Error_Select_BothInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_Error_Select_BothInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wähle sowohl Branche als auch Position aus")
	return /** @type {LocalizedString} */ ("Please select both industry and position")
});